<template>
  <b-modal id="modal-editfolder" title="Update folder">
    <span class="close" @click="onClose">
      <x-icon size="1.25x" class="custom-class"></x-icon>
    </span>
    <div class="">
      <b-form>
        <label class="sr-only" for="inline-form-input-name"
          ><span>Folder name</span>
          <!-- <div class="c-tooltip" v-b-tooltip.hover title="">
            <span>
              ?
            </span>
          </div> -->
        </label>
        <b-input
          id="inline-form-input-name"
          class=""
          placeholder="Research #1"
          v-model="folder.title"
        ></b-input>
        <b-button @click="updateFolder" variant="primary"
          >Update folder</b-button
        >
      </b-form>
    </div>
  </b-modal>
</template>

<script>
import { CheckIcon, XIcon } from "vue-feather-icons";
export default {
  components: {
    XIcon,
    CheckIcon,
  },
  data: function () {
    var obj = {
      lock: false,
      folder: {},
    };
    return obj;
  },
  computed: {},
  methods: {
    onClose: function () {
      this.$bvModal.hide("modal-editfolder");
    },
    setFolder: function (folder) {
      folder = JSON.parse(JSON.stringify(folder));
      this.folder = folder;
    },
    updateFolder: function () {
      this.lock = true;
      this.$store.dispatch("folder/updateFolder", this.folder).then((data) => {
        this.$bvModal.hide("modal-editfolder");
        this.reset();
      });
    },
    reset: function () {
      this.lock = false;
      this.folder = {};
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
#modal-editfolder___BV_modal_outer_ {
  .radio-color {
    .custom-control {
      display: inline-block;
      min-height: auto;
      padding: 0;
      width: 40px;
      height: 40px;
      margin-right: 10px;
    }
  }

  .modal-footer {
    display: none;
  }
  .modal-dialog {
    max-width: 420px;
  }
}
</style>
